import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6 2V8L10 12L6 16V22H18V16L14 12L18 8V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5ZM12 11.5L8 7.5V4H16V7.5L12 11.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "GlassHour"
);
